import React from 'react';
import { FileText, Download } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const isImage = (name = '') => /\.(jpe?g|png|gif|webp|heic)$/i.test(name);

// Renders a chat attachment (image preview or file link). `dark` for amber bubbles.
const DocumentMessage = ({ message, dark }) => {
  const href = `${API_URL}${message.attachment_url}`;
  const name = message.attachment_name || 'Document';
  if (isImage(name)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" data-testid="chat-doc-link" className="block">
        <img src={href} alt={name} className="max-w-[220px] max-h-[220px] rounded-lg border border-white/30 object-cover" />
        <span className={`block text-xs mt-1 ${dark ? 'text-amber-100' : 'text-gray-500'}`}>{name}</span>
      </a>
    );
  }
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="chat-doc-link"
      className={`inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold ${dark ? 'bg-white text-amber-700 hover:bg-amber-50' : 'bg-white text-amber-700 hover:bg-amber-50 border border-amber-200'}`}
    >
      <FileText className="w-4 h-4" /> {name} <Download className="w-4 h-4" />
    </a>
  );
};

export default DocumentMessage;
